/* Modified by LB 2026-07-29 - Quick View cart recovery and direct checkout controller - start */
(function () {
  'use strict';

  if (window.__bcwfcCartConversionInitialised) return;
  window.__bcwfcCartConversionInitialised = true;

  var SELECTORS = {
  quickView: 'quick-view#Quick-view[data-bcwfc-quick-view-recovery], quick-view#Quick-view',
  cartDrawer: 'cart-drawer#CartDrawer[data-bcwfc-cart-drawer-recovery], cart-drawer#CartDrawer',
  quickViewForm: "form[action*='/cart/add'], form[data-type='add-to-cart-form']",
  quickViewTrigger: '[data-bcwfc-quick-view-trigger], [data-product-card-quick-view-button]',
  drawerCheckout: 'a[data-cart-checkout-button]',
  pageCheckout: 'a[data-cart-page-checkout-button]',
  consentCheckbox: '[data-consent-checkbox] input[type="checkbox"], input[data-consent-checkbox], input[id*="ConsentCheckbox"]',

  /* Modified by LB 2026-10-05 - Pre-order checkout popup - start */
  preorderItem: "cart-item[data-bcwfc-preorder-popup='true']",
  preorderPopup: '[data-bcwfc-preorder-popup-modal]',
  preorderPopupDialog: '[data-bcwfc-preorder-popup-dialog]',
  preorderPopupClose: '[data-bcwfc-preorder-popup-close]',
  preorderPopupConfirm: '[data-bcwfc-preorder-popup-confirm]'
  /* Modified by LB 2026-10-05 - Pre-order checkout popup - end */
};

  var state = {
    pendingSubmissions: [],
    recoveryRunning: false,
    sequence: 0
  };

  var nativeFetch = window.fetch.bind(window);

  function getQuickView() {
    return document.querySelector(SELECTORS.quickView);
  }

  function getCartDrawer() {
    return document.querySelector(SELECTORS.cartDrawer);
  }

  function isOpen(element) {
    if (!element) return false;
    return element.isOpen === true || element.classList.contains('is-opened') || element.getAttribute('aria-hidden') === 'false';
  }

  function getVariantIdFromForm(form) {
    if (!form) return '';
    var input = form.querySelector("[name='id']");
    return input && input.value ? String(input.value) : '';
  }

  function rememberQuickViewSubmission(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var quickView = form.closest(SELECTORS.quickView);
    if (!quickView || !form.matches(SELECTORS.quickViewForm)) return;

    var variantId = getVariantIdFromForm(form);
    if (!variantId) return;

    state.sequence += 1;
    state.pendingSubmissions.push({
      sequence: state.sequence,
      variantId: variantId,
      form: form,
      quickView: quickView,
      createdAt: Date.now(),
      handled: false
    });

    form.setAttribute('data-bcwfc-quick-view-submit-pending', String(state.sequence));
    prunePendingSubmissions();
  }

  function prunePendingSubmissions() {
    var cutoff = Date.now() - 20000;
    state.pendingSubmissions = state.pendingSubmissions.filter(function (submission) {
      return !submission.handled && submission.createdAt >= cutoff;
    });
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function requestMethod(input, init) {
    if (init && init.method) return String(init.method).toUpperCase();
    if (input && input.method) return String(input.method).toUpperCase();
    return 'GET';
  }

  function isCartAddRequest(input, init) {
    if (requestMethod(input, init) !== 'POST') return false;

    try {
      var path = new URL(requestUrl(input), window.location.origin).pathname.replace(/\/+$/, '');
      var configuredPath = '';
      if (window.routes && window.routes.cart_add_url) {
        configuredPath = new URL(window.routes.cart_add_url, window.location.origin).pathname.replace(/\/+$/, '');
      }

      return path === configuredPath || /\/cart\/add(?:\.js)?$/.test(path);
    } catch (error) {
      return false;
    }
  }

  function collectIds(value, output) {
    if (value === null || value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach(function (entry) { collectIds(entry, output); });
      return;
    }

    if (typeof value === 'object') {
      Object.keys(value).forEach(function (key) {
        if (key === 'id' || /\[id\]$/.test(key)) {
          output.push(String(value[key]));
        } else {
          collectIds(value[key], output);
        }
      });
    }
  }

  function getRequestVariantIds(init) {
    var ids = [];
    var body = init && init.body;
    if (!body) return ids;

    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        body.forEach(function (value, key) {
          if (key === 'id' || /\[id\]$/.test(key)) ids.push(String(value));
        });
      } else if (typeof body === 'string') {
        try {
          collectIds(JSON.parse(body), ids);
        } catch (jsonError) {
          var params = new URLSearchParams(body);
          params.forEach(function (value, key) {
            if (key === 'id' || /\[id\]$/.test(key)) ids.push(String(value));
          });
        }
      } else if (typeof body === 'object') {
        collectIds(body, ids);
      }
    } catch (error) {
      return [];
    }

    return ids.filter(Boolean);
  }

  function findPendingSubmission(variantIds) {
    prunePendingSubmissions();

    for (var i = state.pendingSubmissions.length - 1; i >= 0; i -= 1) {
      var submission = state.pendingSubmissions[i];
      if (submission.handled) continue;
      if (!variantIds.length || variantIds.indexOf(submission.variantId) !== -1) return submission;
    }

    return null;
  }

  function parseResponsePayload(response) {
    return response.clone().text().then(function (text) {
      if (!text) return {};
      try {
        return JSON.parse(text);
      } catch (error) {
        return {};
      }
    });
  }

  function responseWasSuccessful(response, payload) {
    if (!response || !response.ok) return false;
    if (!payload || typeof payload !== 'object') return true;
    if (payload.status && Number(payload.status) >= 400) return false;
    if (payload.errors || payload.description) return false;
    return true;
  }

  function waitFor(predicate, timeout, interval) {
    timeout = timeout || 1600;
    interval = interval || 100;

    return new Promise(function (resolve) {
      var startedAt = Date.now();

      function check() {
        var result = false;
        try {
          result = Boolean(predicate());
        } catch (error) {
          result = false;
        }

        if (result || Date.now() - startedAt >= timeout) {
          resolve(result);
          return;
        }

        window.setTimeout(check, interval);
      }

      check();
    });
  }

  function drawerContainsVariant(drawer, variantId) {
    if (!drawer || !variantId) return false;
    var items = drawer.querySelectorAll('cart-item[data-variant-id], [data-variant-id]');
    for (var i = 0; i < items.length; i += 1) {
      if (String(items[i].getAttribute('data-variant-id')) === String(variantId)) return true;
    }
    return false;
  }

  function nativeFlowCompleted(variantId) {
    var quickView = getQuickView();
    var drawer = getCartDrawer();
    if (!drawer) return false;

    var quickViewClosed = !quickView || !isOpen(quickView);
    var drawerOpened = isOpen(drawer);
    var drawerUpdated = !variantId || drawerContainsVariant(drawer, variantId) || Boolean(drawer.querySelector('cart-item'));

    return quickViewClosed && drawerOpened && drawerUpdated;
  }

  function clearQuickViewLoading(submission) {
    var quickView = submission && submission.quickView ? submission.quickView : getQuickView();
    var form = submission && submission.form ? submission.form : null;

    if (form) {
      form.removeAttribute('aria-busy');
      form.removeAttribute('data-bcwfc-quick-view-submit-pending');
      form.querySelectorAll("button[type='submit'], [data-product-form-button]").forEach(function (button) {
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
        button.removeAttribute('disabled');
      });
    }

    if (quickView) {
      quickView.querySelectorAll('.loading, [aria-busy="true"]').forEach(function (element) {
        element.classList.remove('loading');
        element.removeAttribute('aria-busy');
      });
    }

    document.querySelectorAll(SELECTORS.quickViewTrigger + '.loading').forEach(function (trigger) {
      trigger.classList.remove('loading');
      trigger.removeAttribute('aria-busy');
    });
  }

  function closeQuickView(submission) {
    var quickView = submission && submission.quickView ? submission.quickView : getQuickView();
    if (!quickView) return Promise.resolve();

    var result;
    try {
      if (typeof quickView.hide === 'function') result = quickView.hide();
    } catch (error) {
      result = null;
    }

    return Promise.resolve(result).catch(function () {}).then(function () {
      if (isOpen(quickView)) {
        quickView.classList.remove('is-opened');
        quickView.setAttribute('aria-hidden', 'true');
        try { quickView.isOpen = false; } catch (error) {}
      }

      var bodyElement = document.querySelector('body-element');
      if (bodyElement && typeof bodyElement.hideOverlay === 'function') {
        try {
          return Promise.resolve(bodyElement.hideOverlay(quickView.id || 'Quick-view')).catch(function () {});
        } catch (error) {
          return undefined;
        }
      }
      return undefined;
    });
  }

  function refreshCartDrawer(drawer, variantId) {
    if (!drawer) return Promise.resolve(false);

    try {
      if (typeof drawer.update === 'function') drawer.update();
    } catch (error) {}

    return waitFor(function () {
      return drawerContainsVariant(drawer, variantId) || (!drawer.hasAttribute('empty-cart') && Boolean(drawer.querySelector('cart-item')));
    }, 2400, 120);
  }

  function openCartDrawer(drawer) {
    if (!drawer) return Promise.resolve();
    if (isOpen(drawer)) return Promise.resolve();

    var result;
    try {
      if (typeof drawer.open === 'function') result = drawer.open();
    } catch (error) {
      result = null;
    }

    return Promise.resolve(result).catch(function () {}).then(function () {
      if (!isOpen(drawer)) {
        var trigger = document.querySelector("[data-sidebar-button][data-sidebar-id='CartDrawer'], [data-cart-drawer-toggle]");
        if (trigger) trigger.click();
      }
    }).then(function () {
      return waitFor(function () { return isOpen(drawer); }, 700, 70);
    }).then(function (opened) {
      if (!opened) {
        drawer.classList.add('is-opened');
        drawer.setAttribute('aria-hidden', 'false');
        try { drawer.isOpen = true; } catch (error) {}
      }
    });
  }

  function runRecovery(submission, payload) {
    if (state.recoveryRunning) return;
    state.recoveryRunning = true;

    var drawer = getCartDrawer();
    var variantId = payload && payload.id ? String(payload.id) : submission.variantId;

    clearQuickViewLoading(submission);

    closeQuickView(submission)
      .then(function () { return refreshCartDrawer(drawer, variantId); })
      .then(function () { return openCartDrawer(drawer); })
      .catch(function () {})
      .finally(function () {
        state.recoveryRunning = false;
      });
  }

  function allowNativeFlowThenRecover(submission, payload) {
    var variantId = payload && payload.id ? String(payload.id) : submission.variantId;

    waitFor(function () {
      return nativeFlowCompleted(variantId);
    }, 1700, 100).then(function (completed) {
      if (!completed) runRecovery(submission, payload || {});
    });
  }

  window.fetch = function (input, init) {
    var isAddRequest = isCartAddRequest(input, init);
    var variantIds = isAddRequest ? getRequestVariantIds(init) : [];
    var submission = isAddRequest ? findPendingSubmission(variantIds) : null;
    var fetchPromise = nativeFetch(input, init);

    if (!submission) return fetchPromise;

    submission.handled = true;

    fetchPromise.then(function (response) {
      return parseResponsePayload(response).then(function (payload) {
        if (responseWasSuccessful(response, payload)) {
          allowNativeFlowThenRecover(submission, payload);
        } else {
          submission.handled = false;
          clearQuickViewLoading(submission);
        }
      });
    }).catch(function () {
      submission.handled = false;
      clearQuickViewLoading(submission);
    });

    return fetchPromise;
  };

  function checkoutIsBlocked(link) {
    if (!link) return true;
    return link.hasAttribute('disabled') || link.getAttribute('aria-disabled') === 'true' || link.getAttribute('data-consent-verify') === 'false' || !link.getAttribute('href');
  }

  function syncCheckoutLink(link) {
    if (!link || !link.matches || !link.matches(SELECTORS.drawerCheckout + ', ' + SELECTORS.pageCheckout)) return;

    var isEmpty = link.hasAttribute('disabled') || !link.getAttribute('href');
    var consentBlocked = link.getAttribute('data-consent-verify') === 'false';
    var disabledValue = isEmpty || consentBlocked ? 'true' : 'false';

    if (link.getAttribute('aria-disabled') !== disabledValue) {
      link.setAttribute('aria-disabled', disabledValue);
    }

    if (isEmpty && link.getAttribute('tabindex') !== '-1') {
      link.setAttribute('tabindex', '-1');
    } else if (!isEmpty && link.getAttribute('tabindex') === '-1') {
      link.removeAttribute('tabindex');
    }
  }

  function syncCheckoutLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTORS.drawerCheckout + ', ' + SELECTORS.pageCheckout).forEach(syncCheckoutLink);
    if (scope.matches && scope.matches(SELECTORS.drawerCheckout + ', ' + SELECTORS.pageCheckout)) syncCheckoutLink(scope);
  }

  /* Modified by LB 2026-10-05 - Pre-order checkout popup controller - start */

    var preorderCheckoutHref = '/checkout';
    var preorderPopupTrigger = null;

    function cartHasPreorderPopupItem() {
      return Boolean(document.querySelector(SELECTORS.preorderItem));
    }

    function getPreorderPopup() {
      return document.querySelector(SELECTORS.preorderPopup);
    }

    function openPreorderPopup(checkoutLink) {
      var popup = getPreorderPopup();
      if (!popup) return false;

      preorderCheckoutHref =
        checkoutLink && checkoutLink.getAttribute('href')
          ? checkoutLink.getAttribute('href')
          : '/checkout';

      preorderPopupTrigger = checkoutLink || document.activeElement;

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bcwfc-preorder-popup-open');

      var dialog = popup.querySelector(SELECTORS.preorderPopupDialog);
      if (dialog && typeof dialog.focus === 'function') {
        window.setTimeout(function () {
          dialog.focus();
        }, 0);
      }

      return true;
    }

    function closePreorderPopup() {
      var popup = getPreorderPopup();
      if (!popup) return;

      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bcwfc-preorder-popup-open');

      if (
        preorderPopupTrigger &&
        document.documentElement.contains(preorderPopupTrigger) &&
        typeof preorderPopupTrigger.focus === 'function'
      ) {
        preorderPopupTrigger.focus();
      }

      preorderPopupTrigger = null;
    }

    function confirmPreorderCheckout() {
      var checkoutHref = preorderCheckoutHref || '/checkout';

      closePreorderPopup();

      window.location.href = checkoutHref;
    }

    function handlePreorderPopupClick(event) {
      var closeButton =
        event.target && event.target.closest
          ? event.target.closest(SELECTORS.preorderPopupClose)
          : null;

      if (closeButton) {
        event.preventDefault();
        closePreorderPopup();
        return;
      }

      var confirmButton =
        event.target && event.target.closest
          ? event.target.closest(SELECTORS.preorderPopupConfirm)
          : null;

      if (confirmButton) {
        event.preventDefault();
        confirmPreorderCheckout();
      }
    }

    function handlePreorderPopupKeydown(event) {
      var popup = getPreorderPopup();

      if (
        event.key === 'Escape' &&
        popup &&
        popup.classList.contains('is-open')
      ) {
        event.preventDefault();
        closePreorderPopup();
      }
    }

    /* Modified by LB 2026-10-05 - Pre-order checkout popup controller - end */

  function focusConsentControl(link) {
    var container = link.closest('cart-drawer, .cart, cart-page, form') || document;
    var checkbox = container.querySelector(SELECTORS.consentCheckbox) || document.querySelector(SELECTORS.consentCheckbox);
    if (checkbox && typeof checkbox.focus === 'function') checkbox.focus({ preventScroll: false });
  }

  function guardCheckoutActivation(event) {
    var target =
      event.target && event.target.closest
        ? event.target.closest(SELECTORS.drawerCheckout + ', ' + SELECTORS.pageCheckout)
        : null;

    if (!target) return;

    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    /*
    * Existing consent / disabled checkout protection remains first.
    */
    if (checkoutIsBlocked(target)) {
      event.preventDefault();
      event.stopPropagation();

      if (target.getAttribute('data-consent-verify') === 'false') {
        focusConsentControl(target);
      }

      return;
    }

    /*
    * Modified by LB 2026-10-05 - Pre-order checkout popup
    *
    * Only intercept checkout when at least one cart item:
    * - has product tag PRE-ORDER POP-UP
    * - has selected variant inventory <= 0
    */
    if (cartHasPreorderPopupItem()) {
      event.preventDefault();
      event.stopPropagation();
      openPreorderPopup(target);
    }
  }

  function initialise() {
    document.addEventListener('submit', rememberQuickViewSubmission, true);
    document.addEventListener('click', guardCheckoutActivation, true);
    document.addEventListener('keydown', guardCheckoutActivation, true);

    /* Modified by LB 2026-10-05 - Pre-order checkout popup - start */
    document.addEventListener('click', handlePreorderPopupClick);
    document.addEventListener('keydown', handlePreorderPopupKeydown);
    /* Modified by LB 2026-10-05 - Pre-order checkout popup - end */

    syncCheckoutLinks(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') syncCheckoutLink(mutation.target);
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) syncCheckoutLinks(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'href', 'data-consent-verify']
    });

    document.addEventListener('shopify:section:load', function (event) {
      syncCheckoutLinks(event.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
/* Modified by LB 2026-07-29 - Quick View cart recovery and direct checkout controller - end */